import PlusIcon from "@/assets/icons/common/plus.svg?react";
import { TematicalColorButton } from "@/components/button/TematicalColorButton/TematicalColorButton";
import { formNotesStore, Note } from "@/stores/NotesStore";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { Element } from "./Element";
import styles from "./NotePatches.module.css";
import { Top } from "./Top";
import { Viewers } from "./Viewers";

export const Item = observer(({ item, editMode }: { item: Note; editMode?: boolean }) => {
  const [viewSelectType, setViewSelectType] = useState(false);
  return (
    <div className={styles.item}>
      <Top
        id={item.id}
        title={item.title}
        version={item.version}
        date_create={item.date_create}
        editMode={editMode}
      />
      <div className={styles.content}>
        {item.elements.map((el, i) => (
          <Element idNote={item.id} editMode={editMode} key={`el${el.id}${i}`} el={el} />
        ))}
        {editMode && (
          <div>
            {!viewSelectType && (
              <div className={styles.types}>
                {" "}
                <TematicalColorButton onClick={() => setViewSelectType(true)}>
                  Добавить элемент
                </TematicalColorButton>
              </div>
            )}
            {viewSelectType && (
              <div className={styles.types}>
                <TematicalColorButton
                  icon={<PlusIcon />}
                  onClick={() => {
                    setViewSelectType(false);
                    formNotesStore.addNoteElement(item.id, "text");
                  }}
                >
                  Текст
                </TematicalColorButton>
                <TematicalColorButton
                  icon={<PlusIcon />}
                  onClick={() => {
                    setViewSelectType(false);
                    formNotesStore.addNoteElement(item.id, "image");
                  }}
                >
                  Изображение
                </TematicalColorButton>
                <TematicalColorButton
                  onClick={() => {
                    setViewSelectType(false);
                  }}
                >
                  Отмена
                </TematicalColorButton>
              </div>
            )}
          </div>
        )}
      </div>

      <Viewers viewers={item.viewers} editMode={editMode || false} />
    </div>
  );
});
